angular.module('dpw.services').factory('dpwAppProfileListService', ['$q', 'api', function ($q, api) {
    return {
        fetchList: fetchList
    };

    function fetchList(options) {
        var orgId = _.get(options, 'orgId');

        return $q(function (resolve) {
            api.call(api.admin.appGallery.listOriginsAndRevisionsWithOrgId({
                orgId: orgId
            }), function (data) {
                resolve(data);
            });
        });
    }
}]);
